import React from 'react';
import css from './Section.module.css';
import { PrimaryButton } from '../../../components';
import Icons from '../../../components/Icons/Icons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function SectionWhyHire(props) {
  const history = useHistory();
  const { intl } = props;
  const data = [
    {
      icon: 'chef',
      titleId: 'SectionWhyHire.item1.title',
      descriptionId: 'SectionWhyHire.item1.description',
    },
    {
      icon: 'securePayment',
      titleId: 'SectionWhyHire.item2.title',
      descriptionId: 'SectionWhyHire.item2.description',
    },
    {
      icon: 'secureCover',
      titleId: 'SectionWhyHire.item3.title',
      descriptionId: 'SectionWhyHire.item3.description',
    },
    {
      icon: 'bill',
      titleId: 'SectionWhyHire.item4.title',
      descriptionId: 'SectionWhyHire.item4.description',
    },
    {
      icon: 'cancellationPolicy',
      titleId: 'SectionWhyHire.item5.title',
      descriptionId: 'SectionWhyHire.item5.description',
    },
    {
      icon: 'cusomterSupport',
      titleId: 'SectionWhyHire.item6.title',
      descriptionId: 'SectionWhyHire.item6.description',
    },
  ];
  return (
    <div className={css.whyHireSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>{intl.formatMessage({ id: 'SectionWhyHire.title' })}</h2>
        </div>

        <div className={css.whyHireContent}>
          {data.map((dataItem, index) => (
            <div className={css.moreInfoBlock} key={index}>
              <div className={css.infoIcon}>
                <Icons name={dataItem.icon} />
              </div>
              <h4>{intl.formatMessage({ id: dataItem.titleId })}</h4>
              <p>{intl.formatMessage({ id: dataItem.descriptionId })}</p>
            </div>
          ))}
        </div>
        <div className={css.sectionHead}>
          <PrimaryButton onClick={() => history.push('/s')}>
            {intl.formatMessage({ id: 'SectionWhyHire.findLocalChef' })} <Icons name="rightAngle" />
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default SectionWhyHire;